"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAEBookingCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _FAEAvatar = require("../FAEAvatar/FAEAvatar");

var _FAEButton = require("../FAEButton/FAEButton");

var _FAEShadowBox = require("../FAEShadowBox/FAEShadowBox");

var _FAEText = require("../FAEText/FAEText");

require("./FAEBookingCard.scss");

const _excluded = ["shadowBoxProps", "className", "buttonProps", "renderButton", "imageProps", "src", "alt", "date", "time", "sessions", "serviceName", "expertName", "expertCard", "avatarProps"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const FAEBookingCard = _ref => {
  let {
    shadowBoxProps,
    className = "",
    buttonProps,
    renderButton,
    imageProps,
    src,
    alt,
    date,
    time,
    sessions = 0,
    serviceName,
    expertName,
    expertCard,
    avatarProps
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FAEShadowBox.FAEShadowBox, _extends({
    padding: expertCard && true
  }, shadowBoxProps), /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "fae--booking-card-main-container ".concat(className)
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--booking-card-image-and-date-time-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--booking-card-image-name-wrapper"
  }, expertCard || window.screen.width < 700 ? /*#__PURE__*/_react.default.createElement("div", {
    className: "fae-expert-card-image"
  }, /*#__PURE__*/_react.default.createElement(_FAEAvatar.FAEAvatar, _extends({}, avatarProps, {
    src: src,
    alt: alt,
    size: window.screen.width < 700 ? "small" : "medium"
  }))) : /*#__PURE__*/_react.default.createElement("img", _extends({}, imageProps, {
    className: "fae--booking-card-image",
    width: "100%",
    height: "100%",
    src: src,
    alt: alt
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--booking-expert-card-details-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--booking-card-service-name"
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    secondary: true
  }, serviceName), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    paragraph: true
  }, expertName)), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--booking-card-date-time"
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    tertiary: true
  }, sessions !== 0 && "Sessions (".concat(sessions, ")")), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    tertiary: true
  }, date), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    tertiary: true
  }, time)))), renderButton && /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--booking-card-button-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_FAEButton.FAEButton, buttonProps, renderButton)))));
};

exports.FAEBookingCard = FAEBookingCard;